import React, { useMemo } from "react";
import PropTypes from "prop-types";
import PnlSummaryLine from "./PnlSummaryLine";
import { calcProfitPerc } from "utils/helpers";

// Realized / unrealized P&L of the strategies in the table (current tab + filter).
const StrategiesOverview = (props) => {
  const { strategies } = props;

  const items = useMemo(() => {
    const closed = strategies.flatMap((s) => s.transactions || []);
    const open = strategies.flatMap((s) => s.openPositions || []);
    const invested = open.reduce((acc, p) => acc + (p.openValue || 0), 0);
    const openPnl = open.reduce((acc, p) => acc + (p.profit?.value || 0), 0);
    return [
      {
        label: "Realized P&L",
        tooltip: "Total closed position P&L of these strategies",
        value: closed.reduce((acc, t) => acc + (t.netProfit?.value || 0), 0),
      },
      {
        label: "Unrealized P&L",
        tooltip: "Total open position P&L of these strategies",
        value: openPnl,
        percent: calcProfitPerc(invested, invested + openPnl),
      },
    ];
  }, [strategies]);

  return <PnlSummaryLine items={items} />;
};

StrategiesOverview.propTypes = {
  strategies: PropTypes.array,
};

export default StrategiesOverview;
